import EStopImage from "./E-Stop.png";

import BPSFaultImageLight from "./BPS Fault.png";
import CellGroupVoltageImageLight from "./Cell Group Voltage.png";
import DischargeEnableLight from "./Discharge Enable.png";
import MPPTContactorImageLight from "./MPPT Contactor.png";
import LowContactorImageLight from "./Low Contactor.png";
import MotorControllerContactorImageLight from "./Motor Controller Contactor.png";
import DoorImageLight from "./Door.png";
import BMSFailuresImageLight from "./BMS Failures.png";
import IMDStatusImageLight from "./IMD Status.png";
import CrashImageLight from "./Crash.png";
import HighCurrentImageLight from "./High Current.png";
import HighVoltageImageLight from "./High Voltage.png";
import LowCurrentImageLight from "./Low Current.png";
import LowVoltageImageLight from "./Low Voltage.png";
import LowBatteryImageLight from "./Low Battery.png";
import MCUCheckImageLight from "./MCU Check.png";
import MPPTCurrentImageLight from "./MPPT Current.png";
import MCStatusImageLight from "./MC Status.png";
import BMSInputVoltageImageLight from "./BMS Input Voltage.png";
import PhysicalConnectionImageLight from "./Physical Connection Lost.png";
import WirelessCommsLostImageLight from "./Wireless Comms Lost.png";
import TemperatureImageLight from "./Temperature.png";
import PackPowerImageLight from "./Pack Power.png";
import PowerWarningsImageLight from "./Power Warnings.png";

import BPSFaultImageDark from "./BPS Fault Dark.png";
import CellGroupVoltageImageDark from "./Cell Group Voltage Dark.png";
import DischargeEnableDark from "./Discharge Enable Dark.png";
import MPPTContactorImageDark from "./MPPT Contactor Dark.png";
import LowContactorImageDark from "./Low Contactor Dark.png";
import MotorControllerContactorImageDark from "./Motor Controller Contactor Dark.png";
import DoorImageDark from "./Door Dark.png";
import BMSFailuresImageDark from "./BMS Failures Dark.png";
import IMDStatusImageDark from "./IMD Status Dark.png";
import CrashImageDark from "./Crash Dark.png";
import HighCurrentImageDark from "./High Current Dark.png";
import HighVoltageImageDark from "./High Voltage Dark.png";
import LowCurrentImageDark from "./Low Current Dark.png";
import LowVoltageImageDark from "./Low Voltage Dark.png";
import LowBatteryImageDark from "./Low Battery Dark.png";
import MCUCheckImageDark from "./MCU Check Dark.png";
import MPPTCurrentImageDark from "./MPPT Current Dark.png";
import MCStatusImageDark from "./MC Status Dark.png";
import BMSInputVoltageImageDark from "./BMS Input Voltage Dark.png";
import PhysicalConnectionImageDark from "./Physical Connection Lost Dark.png";
import WirelessCommsLostImageDark from "./Wireless Comms Lost Dark.png";
import TemperatureImageDark from "./Temperature Dark.png";
import PackPowerImageDark from "./Pack Power Dark.png";
import PowerWarningsImageDark from "./Power Warnings Dark.png";


const FaultsViewImages = {
    "light": {
        "BPSFault": BPSFaultImageLight,
        "CellGroupVoltage": CellGroupVoltageImageLight,
        "DischargeEnable": DischargeEnableLight,
        "EStop": EStopImage,
        "MPPTContactor": MPPTContactorImageLight,
        "LowContactor": LowContactorImageLight,
        "MotorControllerContactor": MotorControllerContactorImageLight,
        "Door": DoorImageLight,
        "BMSFailures": BMSFailuresImageLight,
        "IMDStatus": IMDStatusImageLight,
        "Crash": CrashImageLight,
        "HighCurrent": HighCurrentImageLight,
        "HighVoltage": HighVoltageImageLight,
        "LowCurrent": LowCurrentImageLight,
        "LowVoltage": LowVoltageImageLight,
        "LowBattery": LowBatteryImageLight,
        "MCUCheck": MCUCheckImageLight,
        "MPPTCurrent": MPPTCurrentImageLight,
        "MCStatus": MCStatusImageLight,
        "BMSInputVoltage": BMSInputVoltageImageLight,
        "PhysicalConnection": PhysicalConnectionImageLight,
        "WirelessCommsLost": WirelessCommsLostImageLight,
        "Temperature": TemperatureImageLight,
        "PackPower": PackPowerImageLight,
        "PowerWarnings": PowerWarningsImageLight
    },
    "dark": {
        "BPSFault": BPSFaultImageDark,
        "CellGroupVoltage": CellGroupVoltageImageDark,
        "DischargeEnable": DischargeEnableDark,
        "EStop": EStopImage,
        "MPPTContactor": MPPTContactorImageDark,
        "LowContactor": LowContactorImageDark,
        "MotorControllerContactor": MotorControllerContactorImageDark,
        "Door": DoorImageDark,
        "BMSFailures": BMSFailuresImageDark,
        "IMDStatus": IMDStatusImageDark,
        "Crash": CrashImageDark,
        "HighCurrent": HighCurrentImageDark,
        "HighVoltage": HighVoltageImageDark,
        "LowCurrent": LowCurrentImageDark,
        "LowVoltage": LowVoltageImageDark,
        "LowBattery": LowBatteryImageDark,
        "MCUCheck": MCUCheckImageDark,
        "MPPTCurrent": MPPTCurrentImageDark,
        "MCStatus": MCStatusImageDark,
        "BMSInputVoltage": BMSInputVoltageImageDark,
        "PhysicalConnection": PhysicalConnectionImageDark,
        "WirelessCommsLost": WirelessCommsLostImageDark,
        "Temperature": TemperatureImageDark,
        "PackPower": PackPowerImageDark,
        "PowerWarnings": PowerWarningsImageDark
    }
};

export { FaultsViewImages };
